import CampaignsList from './components/CampaignsList/CampaignsList';
import { NewFormButton } from './components/NewFormButton';
import { AuthContext } from '@urbanx/agx.auth.client';
import { AgxHeader } from '@urbanx/agx-ui-components';
import './CampaignsViewPage.scss';
import { useContext } from 'react';
import { useAppSelector } from 'hooks/useAppSelector';
import { AgencyInfoAccountType } from '@urbanx/agx.agencies.client';
import CampaignsViewSidebar from './CampaignsViewSidebar';
import { LoadingState } from 'utils/loadingState';

const CampaignsViewPage = () => {
  const { userAccount } = useContext(AuthContext);
  const {
    loadingState: agencyInfoLoadingState,
    info: { accountType },
  } = useAppSelector((state) => state.agencies.agencyInfo);
  const hideSideBar =
    agencyInfoLoadingState !== LoadingState.Loaded ||
    accountType === AgencyInfoAccountType.Autopilot;
  const pageClasses = `campaignsViewPage${hideSideBar ? ' hideSideBar' : ''}`;

  return (
    <div className={pageClasses}>
      <div className="dashboardTitle">
        <AgxHeader size={1} inverse>
          {`Welcome back, ${userAccount?.firstName || ''}`}
        </AgxHeader>
        <NewFormButton />
      </div>
      <div className="dashboardMain">
        <CampaignsList />
      </div>
      {!hideSideBar && <CampaignsViewSidebar />}
    </div>
  );
};

export default CampaignsViewPage;
